import store from '@/store'
import router from '@/router'
import routeNames from '@/router/route-names'

export class ErrorManager {
  manageError (error) {
    switch (error.status) {
      case 401:
        router.push({ name: routeNames.MAIN, params: { instance: store.state.configuration.instanceId } })
        break
      case 403:
        router.push({ name: routeNames.ERROR, params: { instance: store.state.configuration.instanceId }, query: { status: error.status } })
        break
      case 408: // timeout, show message
        store.commit('setMessage', { text: window.vm.$t('error.not_found'), color: 'error' })
        break
      case 0: // server unavailable, redirect to error page
        router.push({ name: routeNames.ERROR, params: { instance: store.state.configuration.instanceId }, query: { status: error.status } })
        break
      case 500: // server error, show message
        store.commit('setMessage', { text: window.vm.$t('error.server_error'), color: 'error' })
        break
      case 502:
        router.push({ name: routeNames.NOT_FOUND })
        break
    }
  }
}
